module.exports = __webpack_public_path__ + "data/skeeballPlay.33ca3272226e2bd41294f4b023bd9348.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=data/[name].[hash].json!./app/assets/image/MN/skeeballPlay.json
// module id = 183
// module chunks = 0